import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { debounce, isEmpty } from 'lodash'
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';

import SearchIcon from '@material-ui/icons/Search'
import Autocomplete from '@material-ui/lab/Autocomplete'
import {
  Grid,
  Typography,
  Box,
  TextField,
  InputAdornment
} from '@material-ui/core';

import { useLazyQuery, gql } from '@apollo/client'
import { GET_INVENTORY_BY_BARCODE_ID } from '@/services/inventoryService'

import images from '@/assets/images';
import { Colors } from '@/theme';
import useStyles from './styles';


const InventorySearchInput = ({ onSelectInventory, ...restProps }) => {
  const classes = useStyles();
  const { t } = useTranslation()

  const [inventories, setInventories] = useState([])
  const [isInputBarcode, setIsInputBarcode] = useState(false)

  const [getInventoriesByBarcodeId, { loading: isLoadingInventories }] = useLazyQuery(gql`${GET_INVENTORY_BY_BARCODE_ID}`, {
    onCompleted: (data) => {
      if (isEmpty(data.inventories)) {
        setInventories([{ empty: true }])
      } else {
        setInventories(data.inventories)
      }
    },
    onError: () => {

    },
    fetchPolicy: 'cache-and-network'
  })

  const isBarcode = (input) => input.match(/^[0-9]+$/) != null

  const searchInventories = (input) => {
    setInventories([])
    if (input) {
      getInventoriesByBarcodeId({
        variables: {
          filter: {
            count: true,
            page: 1,
            limit: 10,
            name: isBarcode(input) ? `%%` : `%${input.toLowerCase()}%`,
            bar_code: isBarcode(input) ? `%${input.toLowerCase()}%` : `%%`,
          }
        },
      })
      setIsInputBarcode(isBarcode(input))
    }
  }

  return (
    <Autocomplete
      id="product-search-input"
      freeSolo
      options={inventories}
      renderInput={(params) => (
        <Box style={{ position: 'relative' }}>
          <TextField
            {...params}
            {...restProps}
            placeholder={t('add_product.enter_product_ingredient_name')}
            className={classes.searchInput}
          />
          <SearchIcon
            className={classes.searchIcon}
            fontSize='small'
          />
        </Box>
      )}
      getOptionLabel={(option) => option?.name || ''}
      renderOption={(option, { inputValue }) => {
        if (option?.empty) {
          return (
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
              style={{ paddingTop: 20, paddingBottom: 20 }}
            >
              <Grid item>
                <img src={images.noProducts} width={90} height={90} />
              </Grid>
              <Grid item>
                <Typography className={classes.noMatchingText}>
                  {t('workboard.product_intelligence.no_matching_products')}
                </Typography>
              </Grid>
            </Grid>
          )
        } else {
          const nameMatches = match(option.name, inputValue);
          const nameParts = parse(option.name, nameMatches);

          const barcodeMatches = match(option.bar_code, inputValue);
          const barcodeParts = parse(option.bar_code, barcodeMatches);

          return (
            <Box paddingX={2} paddingY={3}>
              <Box>
                {nameParts.map((part, index) => (
                  <span
                    key={index}
                    style={{
                      fontWeight: part.highlight && !isInputBarcode ? 600 : 400,
                    }}
                  >
                    {part.text}
                  </span>
                ))}
              </Box>
              <Box>
                {barcodeParts.map((part, index) => (
                  <span
                    key={index}
                    style={{
                      fontWeight: part.highlight && isInputBarcode ? 600 : 400,
                    }}
                  >
                    {part.text}
                  </span>
                ))}
              </Box>
            </Box>
          )
        }
      }}
      onInputChange={debounce((e, newInputValue) => searchInventories(newInputValue), 1000)}
      filterOptions={(x) => x}
      loading={isLoadingInventories}
      loadingText={t('workboard.product_intelligence.loading_products')}
      onChange={(event, product) => {
        if (product?.id) {
          onSelectInventory(product)
        } else {
          return
        }
      }}
    />
  )
}

export default InventorySearchInput